import { TYPES } from "./types";
import { aiMessageService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getAIMessages = (query) => async (dispatch) => {
  try {
    const result = await aiMessageService.getAIMessages(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_ALL_AI_MESSAGES_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_ALL_AI_MESSAGES_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
}

export const updateAIMessages = (messages) => async (dispatch) => {
  try {
    const result = await aiMessageService.updateAIMessages(messages);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_ALL_AI_MESSAGES_SUCCESS,
        payload: { data },
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_ALL_AI_MESSAGES_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
}

export const deleteAIMessage = (messageId) => {
  return async (dispatch) => {
    try {
      const response = await await aiMessageService.updateAIMessages([{
        id: messageId,
        is_deleted: true
      }]);
      if (response.data) {
        dispatch({
          type: TYPES.ACTION_DELETE_AI_MESSAGE_SUCCESS,
          payload: { messageId }
        });
        return response.data;
      } else {
        dispatch({
          type: TYPES.ACTION_DELETE_AI_MESSAGE_FAIL,
          payload: {}
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.ACTION_CALL_API_FAIL,
        payload: {
          message: error,
        },
      });
    }
  };
};

export const aiMessageAction = {
  getAIMessages,
  updateAIMessages,
  deleteAIMessage
}
